module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "scroll-to",
    class: {
      'scroll-top': _vm.isPreset
    },
    on: {
      "click": _vm.scrollTo
    }
  }, [_vm._t("default", [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.iconClass]
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eff2f8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll-to/ScrollTo.vue
// module id = 329
// module chunks = 0